import Vue from 'vue'
import Calc from '@platformaone/common-commerce-calc'
import GoogleMapsApiLoader from '@/service/GoogleMapsApiLoader'

import Notification from '@/notification'
import User from '@/service/user'
import Utils from '@/utils'
import Langs from '@/langs'
import Router from '@/router'
import {Intercom} from '@/service/intercom'

import Axios from 'axios'

import Order from '@/order'

import { db, fn } from '@/globals'

/**
 * Service component for working with cart content and the order
 */
var cart = {

  // overlay when displaying 3D secure modal. It has it's own overlay, but we need to scroll up in behind
  globals: {
    overlayActive: false,
    overlayColor: 'light' // light (while processing) | dark (while 3D secure)
  },

  // Google Object for address autocomplete and other stuff
  google: null,

  cartId: null, // The ID of opened cart.
  temporaryCart: false,

  shopId: null, // The ID of shop the cart was created in.
  unsubscribe: null, // Callback for slocing listener for cart changes.
  // parentWindowURL: null,
  lang: 'cs',
  cartLoaded: false,
  orderClosed: false, // After loading the order, this will possibly change
  signature: null,
  // list of active orders
  data: {cartId: null, products: [], delivery: null, payment: null, note: '',
          extra: {},
          total: 0, currency: 'czk', orderNumber: null, processingState: 'init', processingError: null},

  innerPrice: {
    value: 0
  },
  // Configuration of shop details
  shopData: {shippings: [], payments: [], shopName: '', methodPrices : {}, slotConfig: {showNextDayCount: -1, nextDayOrderAt: 'eols'}},

  // Socket for retrieving cart updates
  socket: {},

  openSlotsUnsubscribe: null,

  async loadGoogleApi() {
    console.log('loadGoogleApi()')
      const googleMapsApi = await GoogleMapsApiLoader({
        libraries: ['places'],
        apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        language: 'cs',
        sessiontoken: this.cartId
      })
      this.google = googleMapsApi
      console.log('Google Maps API loaded')
      this.googleLoaded = true
  },

  // Function sets cart identificators and loads the content
  async openCart(shopId, cartId) {
    this.cartId = cartId
    this.shopId = shopId
    return this.loadCartContent()
  },

  // resets cart to initial state
  resetCart() {
    console.log('src/cart: resetCart()')
    this.cart = {}
    console.log('cart was reset to:', this.cart)
    Utils.removeCookie('nur')
    Utils.removeCookie('pfm_cartId')
    Utils.removeCookie('pt')
    // also reset Order
    Order.data = {}
    User.logout()
    window.localStorage.removeItem('emailForSignIn')
    parent.postMessage({action: 'reloadCart'}, '*') // nothing else works TODO: make the fucking reset in-app!
  },

  async loadCartContent() {
    console.log('Loading cart content', this.cartId, this.shopId)

    // test
    // console.log('exported fn:', fn)
    // let testFn = fn.httpsCallable('calls-commerce-cart-update')
    // console.log('testFn:', testFn)
    //
    // try {
    //   let response = await testFn({testPayload: 'lala'})
    //   console.log('testFn response:', response)
    // } catch (e) {
    //   console.error('testFn failed:', e)
    // }

    try {
      let cartDoc = db.collection(`shops/${this.shopId}/carts`).doc(this.cartId)
      let cartData = await cartDoc.get()

      console.log('cartData', cartData)

      if (cartData.data()) {
        let cart = cartData.data()
        console.log('Loaded cart content', cart)

        // Now load shop details
        let shopDoc = db.collection('shops/').doc(this.shopId)
        let shopData = await shopDoc.get()
        if (shopData.data()) {
          let shop = shopData.data()
          // Set the shop details
          console.log('Shop data', shop)
          this.lang = shop.config.language.default
          this.shopData.defaultLang = this.lang
          this.shopData.shopName = shop.config.shopName[this.lang]

          this.shopData.shippings = shop.delivery
          this.shopData.shippings.sort(function (a,b){return a.order-b.order;})

          this.shopData.payments = shop.payment
          this.shopData.payments.methods.sort(function (a,b){return a.order-b.order;})

          // Get the delivery plan
          // this.shopData.deliveryPlan = await this.getDeliveryPlan()

          console.log('Actual shipping and payment from cart', this.shopData.shippings, this.shopData.payments)

          // Will we need the slot overview and some additional data
          // Try to find shipment method requiring slots
          // If the shop has at least some default slots filled, it might use them for actual delivery
          if (shop.deliveryDefaultSlots && shop.deliveryDefaultSlots.length > 0) {
            let firstDate = (new Date()).addDays(-1)
            firstDate.setHours(0)
            firstDate.setMinutes(0)
            firstDate.setSeconds(0)

            console.log(`Selecting slots for ${this.shopId} ${firstDate}`)
            let deliverySlotsDoc = db.collection(`shops/${this.shopId}/deliverySlots`)
              .where('metadata.deleted', '==', false)
              .where("dateFrom", ">=", firstDate)

            deliverySlotsDoc.get()
              .then(deliverySlot => {
                console.log('Loaded delivery slots', deliverySlot.docs.length, deliverySlot)
                if (deliverySlot.docs.length > 0) {
                  deliverySlot.docs.forEach(doc => {
                    let s = doc.data()
                    let methods = Array.isArray(s.enabledFor) ? s.enabledFor : [s.enabledFor]
                    methods.forEach(m => {
                      if (this.shopData.methodPrices[m] === undefined) {
                        Vue.set(this.shopData.methodPrices, m, {n: s.price * 1, x: s.price * 1})
                        // this.shopData.methodPrices[m] = {n: s.methodPrice[m] * 1, x: s.methodPrice[m] * 1}
                      } else {
                        if (this.shopData.methodPrices[m].n > (s.price * 1)) {
                          this.shopData.methodPrices[m].n = s.price * 1
                        } else if (this.shopData.methodPrices[m].x < (s.price * 1)) {
                          this.shopData.methodPrices[m].x = s.price * 1
                        }
                      }
                    })
                  })
                }
                console.log('Method prices', this.shopData.methodPrices)
              })
              .catch(e => {
                console.error('Problem loading Delivery Plan', e)
              })
            if (shop.deliveryPlanning.showNextDayCount != undefined) {
              this.shopData.slotConfig.showNextDayCount = shop.deliveryPlanning.showNextDayCount
            }
            if (shop.deliveryPlanning.nextDayOrder != undefined) {
              this.shopData.slotConfig.nextDayOrderAt = shop.deliveryPlanning.nextDayOrder
            }
            console.log('Shop slot config', JSON.stringify(this.shopData.slotConfig))
          }

          // Set the products details now
          this.data.products = cart.products
          this.data.delivery = cart.delivery
          this.data.payment = cart.payment
          this.data.extra = cart.extra ? cart.extra : {}
          // this.data.processingState = cart.processingState ? cart.processingState : 'init'

          this.data.orderNumber = cart.orderNumber

          // If the cart has Order Number and is in final state, end the whole process... the cart is closed
          if (['success'].includes(cart.processingState)) {
            console.log('The cart has an order number and is in final state.')
            this.data.orderNumber = cart.orderNumber
            this.orderClosed = true
            return
            // throw new Error('Cart closed')
          } else {
            this.data.cartId = this.cartId
          }

          // Corrent Cart content data
          if (this.data.delivery.shipping === undefined) {
            this.data.delivery.shipping = {
              country: null,
              company: {},
            }
          }
          if (this.data.delivery.billing === undefined) {
            this.data.delivery.billing = {
              shippingIsSame: true,
              forCompany: false,
              company: {},
            }
          }
          if (this.data.delivery.slot === undefined) {
            this.data.delivery.slot = -1
          } else {
            console.log('Checking the selected slot', this.data.delivery.slot)
            // The date cannot be in the past
            if (this.data.delivery.slot && this.data.delivery.slot.mark) {
              let now = new Date()
              let slotDate = (now).fromYyyymmdd(this.data.delivery.slot.mark)
              console.log(slotDate.getTime(), now.getTime(), slotDate >= now)
              if (slotDate < now) {
                console.log('Removing wrong slot')
                this.data.delivery.slot = -1
              }
            }
          }
          this.data.userIdentification = cart.userIdentification
          this.data.userSubsribed = cart.userSubsribed
          this.data.rulesAccepted = cart.rulesAccepted
          if (this.data.rulesAccepted === undefined) {
            this.data.rulesAccepted = false
          }

          // this.siteId = cart.data.siteId .... may be not needed
          // this.data.userId = cart.userId

          this.cartLoaded = true
          console.log('Loading cart is done')
        } else {
          console.error('Error loading shop definition')
        }

        // This will listen for changes of the CART
        this.unsubscribe = db.doc(`shops/${this.shopId}/carts/${this.cartId}`)
            .onSnapshot(doc => {
              let cartUP = doc.data()
              console.log(`cart changed | DB processingState: [${cartUP.processingState}], LOCAL processingState: [${this.data.processingState}]`)

              // ignore any action, if LOCAL processingState == 'pendingPayment' & changed data is not processingState == 'success' || 'failed'
              if (['working', 'pendingPayment'].includes(this.data.processingState) && !['success', 'failed'].includes(cartUP.processingState)) {
                console.log('cart changed while LOCAL processingState is pendingPayment and the change is not successful or failed processingState -> ignoring')
                return
              }

              // let stateReallyChanged = this.data.processingState != cartUP.processingState
              // console.log(`Cart changed${stateReallyChanged ? ' with state': ', but not the state'}. From ${this.data.processingState} => ${cartUP.processingState}`, cartUP)

              // console.log((this.innerPrice.value == cartUP.totalPrice) ? '>>> The price is still the same <<<' : '>>> Price changed <<<')
              // This value is there for component requiring the price being already saved in cart. Such as PayU gate.
              this.innerPrice.value = cartUP.totalPrice

              this.data.note = cartUP.note
              this.data.total = cartUP.totalPrice
              this.data.currency = cartUP.currency
              // this.data.processingState = cartUP.processingState ? cartUP.processingState : 'init'
              // this.data.orderNumber = cartUP.orderNumber

              if (cartUP.processingState == 'success') {
                this.closeOrder(cartUP.orderNumber)
                return
              } else if (cartUP.processingState == 'failed') {
                this.globals.overlayActive = false

                // This timeout is here to scroll even lower to the payment button.
                setTimeout(() => {
                  this.data.processingState = cartUP.processingState
                  Utils.scrollTo({
                    targetElementId: 'process-order-button-wrap'
                  })
                  setTimeout(() => {
                    this.data.processingState = 'init'
                  }, 2000)
                }, 1000)
              } else if (cartUP.processingState == 'pendingPayment' && this.data.processingState != 'failed') {
                console.log('Showing overlay')
                this.globals.overlayActive = true
                this.globals.overlayColor = 'light'
              } else {
                this.data.processingState = cartUP.processingState ? cartUP.processingState : 'init'
              }


              // Update the products list (and counts)
              // Unfortunaltely we can't just replace the array, because the vue references would be lost
              if (this.data.processingState == 'init') {
                let presentProducts = this.data.products.map(p => {return p.snapshot.id})
                let newProducts = []
                console.log('Current products', presentProducts)
                cartUP.products.forEach(newP => {
                  console.log('deciding product:', newP, (presentProducts.indexOf(newP.snapshot.id) > -1))
                  if (presentProducts.indexOf(newP.snapshot.id) > -1) {
                    // Product was there, update the count
                    console.log('Product was there, update the count')
                    let prod = this.data.products.filter(locP => {return newP.snapshot.id == locP.snapshot.id})

                    // There should be just one item
                    console.log('There should be just one item')
                    prod[0].count = newP.count

                    // If the product was temporary, replace the snapshot
                    if (prod[0].temporary) {
                      prod[0].snapshot = newP.snapshot
                      delete prod[0].temporary
                    }
                  } else {
                    // The product was not in the current list
                    console.log('The product was not in the current list')
                    this.data.products.push(newP)
                    console.log('pushed product into products', this.data.products)
                  }
                  console.log('Pushing product', newP.snapshot.id)
                  newProducts.push(newP.snapshot.id)
                })
                if (newProducts.length != presentProducts.length) {
                  // The count of products has changed, some products are missing now.
                  console.log('The count of products has changed, some products are missing now.')
                  for(let i = 0; i < this.data.products.length; i++) {
                    if (newProducts.indexOf(this.data.products[i].snapshot.id) == -1) {
                      // The product was removed
                      console.log('The product was removed')
                      this.data.products.splice(i,1)
                    }
                  }
                }
                console.log('New products', newProducts)
              }

            })


      } else {
        // TODO handle some errors, like the cart or shop doesn't exists
        console.error('No cart data loaded')
        this.cartLoaded = false
      }

      console.log('Returning cart data', this.data)
      return this.data
    } catch (e) {
      if (!this.unsubscribe) {
        console.error('cart does not exist:', e)
      } else {
        console.error('cart loading error:', e)
      }
    }
  },

  async temporaryProductInsert(newProduct) {
    console.log('Adding product from the shop', this, newProduct)
    if (this.cartId == null) {
      console.log('The cart was not provided, we shal make this temporary')
      this.temporaryCart = true
    }

    // Add the product
    let presentProductIds = this.data.products.map(p => {return p.snapshot.id})

    if (presentProductIds.indexOf(newProduct.snapshot.id) > -1) {
      // Product was there, update the count
      let prod = this.data.products.filter(locP => {return newProduct.snapshot.id == locP.snapshot.id})
      // There should be just one item
      prod[0].count = newProduct.count
    } else {
      // The product was not in the current list
      newProduct.temporary = true
      this.data.products.push(newProduct)
    }
    // Calculate the cart
    let calculation = Calc.calculate({
      products: this.data.products,
      delivery: this.data.delivery,
      payment: this.data.payment,
    })
    console.log('Locally calculated', calculation)
    let currency = 'CZK'
    if (calculation && calculation.state && calculation.state == 'ok') {
      let totalCalc = calculation.filter(c => {
        return c.type == 'total'
      })
      this.data.currency = totalCalc[0].currency
      this.data.total = totalCalc[0].brutto
    }

    // The cartId might not exist. In that case, create the cart first
    if (this.cartId == null) {
      console.log('Creating new cart')

      let req = {
        shopId: this.shopId,
        cartData: {
          product: {
            id: newProduct.id ? newProduct.id : newProduct.snapshot.id,
            count: newProduct.count,
          },
          meta: {
            cart: {
              version: process.env.VUE_APP_VERSION
            }
          }
        }
      }

      let cartCreateFn = fn.httpsCallable('calls-commerce-cart-create')
      let response = await cartCreateFn(req)
      console.log('Created cart', response)

      this.temporaryCart = false

      this.openCart(this.shopId, response.data.cartId)

      // Sned the ID to the site
      parent.postMessage({action: 'cartCreated', cartId: response.data.cartId}, '*')

    } else {
      console.log('Adding product into already created cart')
      this.temporaryCart = false

      try {
        let cartUpdateFn = fn.httpsCallable('calls-commerce-cart-updateProducts')
        let response = await cartUpdateFn({
          shopId: cart.shopId,
          cartId: cart.cartId,
          productData: {
        		id: newProduct.id ? newProduct.id : newProduct.snapshot.id,
        		count: newProduct.count
        	}
        })
        console.log('cartUpdateFn response:', response)
      } catch (e) {
        console.error('cartUpdateFn failed:', e)
        Notification.add('err', e, 30)
      }

    }
  },

  /**
   * Sets count of given product in loaded cart.
   */
  async setCount(productId, count) {
    let prod = this.data.products.filter(locP => {return productId == locP.snapshot.id})
    if (prod == undefined) {
      return false
    }

    // First check the product availability if we are adding
    if (prod[0].count < count) {
      let productOnStockFn = fn.httpsCallable('calls-commerce-product-onStock')
      let response = await productOnStockFn({
        shopId: this.shopId,
        productId: productId,
      })
      if (!response.data.available) {
        console.log('The product is not available', response)
        return {available: false}
      }
    }

    // Now make the change locally
    prod[0].count = count

    // Calculate the cart
    let calculation = Calc.calculate({
      products: this.data.products,
      delivery: this.data.delivery,
      payment: this.data.payment,
    })
    console.log('Locally calculated', calculation)
    let currency = 'CZK'
    if (calculation && calculation.state && calculation.state == 'ok') {
      let totalCalc = calculation.filter(c => {
        return c.type == 'total'
      })
      this.data.currency = totalCalc[0].currency
      this.data.total = totalCalc[0].brutto
    }

    // Now set the change to the server
    Utils.onPause('saving-cart-service', async () => {
      // let req = {
      //   "product": {
      // 		"id": productId,
      // 		"count": count,
      // 		"mode": "SET"
      // 	}
      // }
      // Axios.put(process.env.VUE_APP_FNC_URL + `/v1/commerce/${this.shopId}/cart/${this.cartId}`, req)
      // .then(up => {
      //   console.log('Set count done', up.state)
      // })
      // .catch(err => {
      //   // Updated of count failed
      //   console.log('Set count failed')
      // })

      try {
        let cartUpdateFn = fn.httpsCallable('calls-commerce-cart-updateProducts')
        let response = await cartUpdateFn({
          shopId: this.shopId,
          cartId: this.cartId,
          productData: {
        		id: productId,
        		count: count,
        		mode: "SET"
        	}
        })
        console.log('cartUpdateFn response:', response)
        return true
      } catch (e) {
        console.error('cartUpdateFn failed:', e)
        Notification.add('err', e, 30)
        return false
      }

    }, 100)

    // The result
    return {available: true}
  },

  getOrderSize() {
    let total = 0
    this.data.products.forEach(prodWrap => {
      if (prodWrap.snapshot.config && prodWrap.snapshot.config.settings && !isNaN(prodWrap.snapshot.config.settings.prepTime)) {
        total += prodWrap.count * prodWrap.snapshot.config.settings.prepTime
      }
    })
    return total
  },

  async saveCart(instruction) {
    if (!this.temporaryCart) {
      Utils.onPause('saving-cart-service', this.performSaveCart, 100, this)
    }
  },

  async performSaveCart(cart) {
    console.log('Saving cart', cart.data)

    try {
      let cartUpdateFn = fn.httpsCallable('calls-commerce-cart-updateInfo')
      let response = await cartUpdateFn({
        shopId: cart.shopId,
        cartId: cart.cartId,
        cartData: cart.data
      })
      console.log('cartUpdateFn response:', response)
      return true
    } catch (e) {
      console.error('cartUpdateFn failed:', e)
      Notification.add('err', e, 30)
      return false
    }
  },

  // This gets the payment token for credit cart online payment
  // async getPaymentAuthToken(force) {
  //   console.log('Getting payment token')
  //   let cookiePaymentToken = Utils.getCookie('pt')
  //   if (cookiePaymentToken && cookiePaymentToken.length > 20 && force === undefined) {
  //     console.log('Got from cookie')
  //     return cookiePaymentToken
  //   } else {
  //     // Retrieves the payment auth token
  //     return Axios.get(process.env.VUE_APP_FNC_URL + `/v1/commerce/${this.shopId}/payment/${this.cartId}/method/${this.data.payment.methodCode}`)
  //     .then(token => {
  //       console.log('Auth token', token)
  //       Utils.setCookie('pt', token.data.client_secret, 1/24)
  //       return token.data.client_secret
  //     })
  //     .catch(err => {
  //       console.error(err)
  //       return null
  //     })
  //   }
  // },

  // The payment was requested at the Payment Gate Provider, now process the server request.
  // async placePayment(paymentInstructions) {
  //   console.log('Payment instructions', paymentInstructions)
  //   if (!this.isCartValid()) {
  //     console.error('Submit not possible, cart not valid')
  //     return
  //   }
  //   // Notification.showWIP('...');
  //   // This exact request is for Braintree implementation. It is probable, that for another method another payload will be required.
  //   return Axios.post(process.env.VUE_APP_FNC_URL + `/v1/commerce/${this.shopId}/payment/${this.cartId}/method/${this.data.payment.methodCode}`, {paymentInstructions: paymentInstructions})
  //   .then(result => {
  //     if (result.data.success) {
  //       this.closeOrder(result.data.orderNumber)
  //     } else {
  //       Notification.add('err', result.data, 30)
  //     }
  //     Notification.hideWIP(true);
  //   })
  //   .catch(err => {
  //     this.submitFailed(err)
  //     return false
  //   })
  // },

  // Creates only a new order, the user shall pay later
  async placeOrder() {
    // Notification.add('info', 'Not now', 20)
    // return
    Notification.showWIP('...');
    console.log('Submitting order', this.data)
    if (!this.isCartValid()) {
      console.log('Submit not possible, cart not valid')
      return
    }
    // Nothing additional is required. All should by in the Cart by now.
    return Axios.post(process.env.VUE_APP_FNC_URL + `/v1/commerce/${this.shopId}/payment/${this.cartId}/method/${this.data.payment.methodCode}`, {})
    .then(result => {
      if (result.data.success) {
        this.closeOrder(result.data.orderNumber)
      } else {
        Notification.add('warn', result.data, 30)
        this.data.processingState = 'failed'
        this.globals.overlayActive = false
      }
      Notification.hideWIP(true);
    })
    .catch(err => {
      this.submitFailed(err)
      return false
    })
  },

  isCartValid() {
    let valid = true
    let lastError = null
    // Check the delivery slot
    if (this.data.delivery && this.data.delivery.code == 'CUSTOM') {
      // The slot should be selected
      if (this.data.delivery.slot == null || this.data.delivery.slot == undefined || this.data.delivery.slot == -1) {
        valid = false
        lastError = 'MISSING_DELIVERY_PRICE'
      }
    }
    // The slot should be selected - If the slot is == -1, than it is not erquired
    if (this.data.delivery.slot == null || this.data.delivery.slot == undefined) {
      valid = false
      lastError = 'MISSING_DELIVERY_PRICE'
    }
    // The slot should be in the future
    if (this.data.delivery.slot && this.data.delivery.slot.validUntil && this.data.delivery.slot.validUntil < new Date()) {
      valid = false
      lastError = 'SLOT_IN_PAST'
    }

    if (!valid) {
      this.submitFailed({response: {data: {code: lastError}}})
    }
    return valid
  },

  submitFailed(err) {
    console.error(err.response.data)
    Notification.hideWIP(true);

    if (err.response.data && err.response.data.code) {
      this.data.processingError = err.response.data.code
      Notification.add('err', 'Chyba při zpracování objednávky', 30)
    }
    this.data.processingState = 'failed'
    this.globals.overlayActive = false
    setTimeout(() => {
      this.data.processingState = 'init'
    }, 2000)
  },

  // TODO might not be necessary anymore... the order will be closed by Payment Service and particular Mayment Module
  // yes, it is very much necessary.
  closeOrder(orderNumber) {
    this.data.processingState = 'success'
    this.orderClosed = true
    this.unsubscribe()
    console.log('cart/index.js:closeOrder()')
    setTimeout(() => {
      console.log('setting order number', orderNumber)
      this.data.orderNumber = orderNumber

      // save order data to Order handler so we can show it in confirmation
      Order.data = this.data

      Utils.removeCookie('nur')
      Utils.removeCookie('pfm_cartId')
      Utils.removeCookie('pt')
      User.logout()
      this.globals.overlayActive = false
      Router.push({name: 'Confirmation', params: {order_number: this.data.orderNumber}})
    }, 1000)
  },

  fillEmptyParts() {
    console.log('Filling empty parts of the order')
    // Create ampty object structure of delivery
    if (!this.data.delivery) {
      console.log('Filling Delivery')
      this.data.delivery = {
                            module_id: -1,
                            price: {vat: 0, vat_pct: 0, currency: '', excl_vat: 0, incl_vat: 0},
                            params: {
                            	billing: {
                            		city: '',
                            		name: '',
                            		phone: '',
                            		postal: '',
                            		street: {name: '',number: ''},
                            		company: { ic: '', dic: '', name: '' },
                            		country: null,
                            		surname: '',
                                shippingIsSame: true
                            	},
                            	shipping: {
                            		city: '',
                            		name: '',
                            		phone: '',
                            		postal: '',
                            		street: {name: '',number: ''},
                            		company: { ic: '', dic: '', name: '' },
                            		country: null,
                            		surname: ''
                            	}
                            }
                          }
    }

    if (!this.data.payment) {
      console.log('Filling payment')
      this.data.payment = {
                        		price: {vat: 0, vat_pct: 0, currency: '', excl_vat: 0, incl_vat: 0},
                        		module_id: -1,
                        		paymentId: '',
                        		status_current: '',
                        		status_history: []
                        	}
    }

  },

}

function receiveMessage(event) {
  // console.log('receiveMessage', event)

  if (event && event.data) {

    // var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data


    var data = null

    if (typeof event.data === 'object') {
      data = event.data
    } else if (typeof event.data === 'string') {
      if (Utils.hasJsonStructure(event.data)) {
        data = JSON.parse(event.data)
      } else {
        data = event.data
      }
    }

    // console.log('got message:', data)

    // get parent page URL when it's changed
    // if (data.currentUrl) {
    //   cart.parentWindowURL = data.currentUrl
    // }

    // get cart id when it becomes known (after adding the first product)
    if (data.cartId) {
      cart.cartId = data.cartId
      Router.replace({
        name: 'Order',
        params: {
          shopId: data.shopId,
          cartId: data.cartId
        }
      })
    }

    // If the product is being added
    if (data.product) {
      cart.shopId = data.shopId
      cart.temporaryProductInsert(data.product)
    }

    // stripe requests 3ds modal
    if (data.message && data.message.action == 'stripe-safe-controller-action-response') {
      // if (data.message.payload && data.message.payload.nonce.match(/AUTHENTICATE_3DS/g)) {
      if (data.message.payload && data.message.payload.caRes && data.message.payload.caRes.object && data.message.payload.caRes.object.status == 'requires_action') {
        console.log('STRIPE: we have a 3DS request coming up')
        // activate overlay
        cart.globals.overlayActive = true
        cart.globals.overlayColor = 'dark'
        // scroll to top - THIS IS BECAUSE FIXED ELEMENTS WEBKIT BUG ON IOS
        // Utils.scrollTo({
        //   y: 0
        // })
        console.log('scrolling to top')
        window.scrollTo(0,0)
      }
    }

    // app-client intercom user ids
    if (data.intercom) {
      Intercom.context.visitorId = data.intercom.visitorId
      Intercom.context.visitorUserId = data.intercom.visitorUserId
      console.log('updated intercom visitor ids')
    }


  }
}
window.addEventListener('message', receiveMessage, false)


export default cart
